import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(process.env.REACT_APP_SUPABASE_URL, process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY, {
  auth: { flowType: 'pkce', persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
});

const callbackUrl = () => `${window.location.origin}/auth/callback`;
export const signUp = (email, password, fullName, marketing = false) => supabase.auth.signUp({ email, password, options: { emailRedirectTo: callbackUrl(), data: { full_name: fullName, marketing_opt_in: marketing } } });
export const signIn = (email, password) => supabase.auth.signInWithPassword({ email, password });
export const signInWithGoogle = async (next) => {
  const res = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/auth/v1/settings`, { headers: { apikey: process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY } });
  const settings = res.ok ? await res.json() : null;
  if (!settings?.external?.google) return { error: { message: 'Google sign-in is not enabled yet. Please use email and password.' } };
  return supabase.auth.signInWithOAuth({ provider: 'google', options: { redirectTo: `${callbackUrl()}?next=${encodeURIComponent(next || '/app')}` } });
};
export const resendConfirmation = (email) => supabase.auth.resend({ type: 'signup', email, options: { emailRedirectTo: callbackUrl() } });
export const requestPasswordReset = (email) => supabase.auth.resetPasswordForEmail(email, { redirectTo: `${callbackUrl()}?next=/reset-password` });
export const updatePassword = (password) => supabase.auth.updateUser({ password });
export const signOut = () => supabase.auth.signOut();

export const safeNext = (value, fallback = '/app') => {
  if (!value || !/^\/(?!\/)/.test(value) || value.includes('\\') || [...value].some((c) => c.charCodeAt(0) < 32)) return fallback;
  try { return new URL(value, window.location.origin).origin === window.location.origin ? value : fallback; } catch { return fallback; }
};
